import ExportData from '@/components/pages/export-data/ExportDataPage.vue'

export default [
    {
      path: 'export-data',
      name: 'export.data',
      meta: { access: { menu: 'analytics', subMenu: 'export-learning-history-report' } },
      component: ExportData
    }
  ]